var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64C14.356 64 0 49.644 0 32S14.356 0 32 0s32 14.356 32 32-14.356 32-32 32z",
    fill: "#FE6971"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.736 14.404a3.178 3.178 0 0 0-2.244-.93c-.843 0-1.647.328-2.244.93L32.975 27.552l-12.951-13.11a3.207 3.207 0 0 0-4.48-.023c-1.249 1.213-1.264 3.219-.039 4.47L30.7 34.249a3.183 3.183 0 0 0 4.488.007l15.533-15.375a3.174 3.174 0 0 0 .023-4.462l-.008-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.736 48.473a3.178 3.178 0 0 1-2.244.93 3.146 3.146 0 0 1-2.244-.93L32.975 35.325l-12.951 13.11a3.207 3.207 0 0 1-4.48.023c-1.249-1.213-1.264-3.219-.039-4.47L30.7 28.629a3.183 3.183 0 0 1 4.488-.007l15.533 15.375a3.174 3.174 0 0 1 .023 4.462l-.008.015z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMark);
export default __webpack_public_path__ + "static/media/error-mark.36a76105a3965caf2377a576316ebb17.svg";
export { ForwardRef as ReactComponent };